import type { ComponentPropsWithRef } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { Button } from '../Button/Button';
import { Illustration } from '../Illustration/Illustration';
import { ExternalLink } from '../Link/ExternalLink';
import { Text } from '../Text/Text';
import { contentStyle, contentWrapperStyle, illustrationStyle, titleStyle } from './CardError.css';

type Props = ComponentPropsWithRef<'div'> & {
  onRetry?: () => void;
  title: string;
};

export const CardError = ({ onRetry, title, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <div {...delegated} className={clsx(contentWrapperStyle, delegated.className)}>
      <Illustration className={illustrationStyle} name="Error" strokeWidth={1.1} />
      <div className={contentStyle}>
        <Text className={titleStyle}>{title}</Text>

        <Text>
          <Trans components={{ email: <ExternalLink /> }} i18nKey="common:errors.contactSupport" />
        </Text>
      </div>
      {onRetry && (
        <Button emphasis="secondary" icon="Sync" onClick={onRetry}>
          {t('common:actions.retry')}
        </Button>
      )}
    </div>
  );
};
